import React from "react";
import { Header, Segment } from "semantic-ui-react";

const PrestamoListEmpty = () => {
  return (
    <Segment textAlign="center">
      <Header as="h4" color="blue">
        No tiene deuda pendiente de pago.
      </Header>
    </Segment>
  );
};

export default PrestamoListEmpty;
